<template>
    <div class="info-form-item">
        <span class="info-form-item__label">{{ label }}</span>
        <div class="info-form-item__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        label: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    watch: {},
};
</script>

<style lang="scss" scoped>
.info-form-item {
    margin-bottom: 10px;
    display: flex;
    box-sizing: border-box;
    line-height: 1.5;
    &__label {
        display: inline-block;
        vertical-align: top;
        padding-right: 12px;
        flex-shrink: 0;
    }
    &__content {
        display: inline-block;
        vertical-align: top;
    }
}
</style>
